var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00001 11.75C0.901471 11.7505 0.80383 11.7312 0.712818 11.6935C0.621806 11.6557 0.539256 11.6001 0.470012 11.53C0.329561 11.3894 0.250671 11.1987 0.250671 11C0.250671 10.8012 0.329561 10.6106 0.470012 10.47L4.94001 6L0.470012 1.53C0.337532 1.38782 0.265408 1.19978 0.268836 1.00548C0.272264 0.811175 0.350977 0.62579 0.48839 0.488377C0.625803 0.350964 0.811188 0.272252 1.00549 0.268824C1.19979 0.265396 1.38784 0.337519 1.53001 0.469999L6.53001 5.47C6.67046 5.61062 6.74935 5.80125 6.74935 6C6.74935 6.19875 6.67046 6.38937 6.53001 6.53L1.53001 11.53C1.46077 11.6001 1.37822 11.6557 1.2872 11.6935C1.19619 11.7312 1.09855 11.7505 1.00001 11.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.55f4249f4aea14bfde4278e16504a7d0.svg";
export { ForwardRef as ReactComponent };